export default {
    'current-ticket': state => state.currentTicket,
    'current-client': state => state.currentClient,
    'tickets': state => state.tickets
}